import { useCallback } from 'react';
import { useSendOnCopilotChannel } from '../channel/hooks/useSendOnCopilotChannel';
export const useOpenCopilot = () => {
  const openCopilot = useSendOnCopilotChannel('OPEN_COPILOT');
  return useCallback(options => {
    openCopilot(options);
  }, [openCopilot]);
};